<template>
	<div class="container-fluid rtl">
		<div class="panel panel-default">
			<div class="panel-heading">
				<h3 class="panel-title rtl">רשימת פרויקטים</h3>
			</div>
			<div class="container-fluid addSomePadding">
				<div class="col-md-12 table-responsive">
					<table class="table" v-loading="loading">
						<thead>
							<tr>
								<th>שם הפרויקט</th>
								<th>כלים</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in list" :key="item.id">
								<td><router-link :to="'/category/'+item.id">{{item.name}}</router-link></td>
								<td>
                  <a href="javascript:void(0)" v-on:click.prevent="edit(item)">
										<span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>
									</a>
                  &nbsp;


                  <a class="text-danger" href="javascript:void(0)" v-on:click.prevent="remove(item.id)">
										<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
									</a>
								</td>
							</tr>
						</tbody>
          </table>
          <div class="text-center col-md-12" dir="ltr">
            <el-pagination layout="prev, pager, next" @current-change="callList" :total="total"></el-pagination>
          </div>
          <div class="text-center col-md-12">
            <button type="button" class="btn btn-primary" v-on:click.prevent="add({id:0,name:''})">הוסף פרוייקט</button>
          </div>
				</div>
			</div>
		</div>
		<div class="popupForm" v-if="obj != null">
			<div class="panel-heading">
				<h3 class="panel-title" v-text="addEditTitle">Save Category</h3>
			</div>
			<div class="container-fluid addSomePadding">
				<div-vali class="col-md-12" :errorVee="errors.has('name')" labelTxt="שם פרויקט">
					<input type="text" name="name" class="form-control" v-model="obj.name" v-validate data-vv-rules="required">
        </div-vali>
				<div class="text-center col-md-12">
					<button type="button" class="btn btn-warning" v-on:click.prevent="cancel()">ביטול</button>
					<button type="button" class="btn btn-primary" v-on:click.prevent="save()">שמור</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Util from "@/util/Utils2.js";
import DivValidation from "@/components/shared/utils/DivValidation.vue";
import BasicoService from "@/service/BasicoService.js";
export default {
  components: {
    "div-vali": DivValidation
  },
  data() {
    return {
      loading: true,
      total: 0,
      obj: null,
      list: [],
      addEditTitle:"הוספת פרויקט חדש"
    };
  },
  methods: {
    callList(page=1) {
      this.loading = true
      let basicoService = new BasicoService(this);
      basicoService.categoryList(page).then(list => {
        if (list) {
          this.total = list.data.total
          this.list = list.data.data
        }
        this.loading = false
      });
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let basicoService = new BasicoService(this);
          basicoService.categorySave(this.obj).then(res => {
            if (res) {
              Util.showMessage("פרויקט נשמר", "success");
            } else {
            }
            this.cancel();
          });
        }
      });
    },
    remove(id) {
      if (confirm("בטוח להסיר?")) {
        let basicoService = new BasicoService(this);
        basicoService.categoryDelete(id).then(res => {
          if (res) {
            Util.showMessage("פרויקט נמחק", "success");
          } else {
          }
          this.cancel();
        });
      }
    },
    add(obj) {
      this.obj = obj;
       this.addEditTitle='הוספת פרויקט חדש';
    },
    edit(obj) {
      this.obj = obj;
      this.addEditTitle='עריכת פרויקט קיים';
    },
    cancel() {
      this.obj = null;
      this.callList();
    }
  },
  created() {
    this.callList();
  }
};
</script>
<style>
.popupForm{
  position: fixed;
  top:50%;
  left:50%;
  width:700px;
  height:250px;
  margin-left:-350px;
  margin-top:-125px;
  background-color: rgba(255,255,255,0.95);
  border:#2c2c2c 1px solid;
  border-radius: 5px;
  -webkit-box-shadow: 1px 11px 41px -6px rgba(0,0,0,0.75);
-moz-box-shadow: 1px 11px 41px -6px rgba(0,0,0,0.75);
box-shadow: 1px 11px 41px -6px rgba(0,0,0,0.75);
}
.table thead tr th {
  background-color: #2980b9;
  color: #fff;
  font-size: 28px;
  border-left: 1px #3498db solid;
  width: 100%;
  text-align: right;
  padding-right:20px;
}
.table thead tr th span {
  font-size: 16px;
}
.table thead tr th:last-child {
  border-left: none;
}
.table tbody tr td {
  font-size: 24px;
  color: #2c2c2c;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  padding-right: 20px;
  padding-left: 20px;
}
.table tbody tr td:last-child {
  border-left: 1px solid #e8e8e8;
}
.table tbody tr td:last-child {
  white-space: nowrap;
}
.table tbody tr:nth-child(odd) {
  background-color: #dee9f1;
}
.table tbody tr td:not(:last-child) span {
  font-size: 18px;
}
.table tfoot tr td {
  text-align: center;
  font-size: 14px;
}
.table tfoot tr td div.paging {
  text-align: center;
  display: inline;
}
.table tfoot tr td div.resultsSummery {
  float: right;
}
.table tfoot tr td div.numOfRows {
  float: left;
}
.mainContainer {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// Category.vue?a800b8d8